import React, { useState, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import ScrollableFeed from "react-scrollable-feed";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CartContext } from "../context/CartContext";
import order_apis from "../apis/includes/order_apis";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import loader from "../assets/images/loader.gif";
import Invoice from "./Invoice";
import { useReactToPrint } from "react-to-print";
import Model from './models/CashModel'; // Import the Modal component


const CartItems = () => {
  const cartContext = useContext(CartContext);
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [is_loading, setIsLoading] = useState(false);
  const invoiceRef = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [receivedAmount, setRecievedAmount] = useState(0.00);



  const handlePrint = useReactToPrint({
    content: () => invoiceRef.current,
    onAfterPrint: () => {
      cartContext.clearCart();
      window.location.reload();
    },
  });

  const currentDate = new Date();
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const month = monthNames[currentDate.getMonth()];
  const day = currentDate.getDate();
  const year = currentDate.getFullYear();
  const formattedDate = `${month} ${day}, ${year}`;

  const getTotalBill = () => {
    let total = 0;
    let actualCost = 0;
    cartContext.cartItems.forEach((item) => {
      total += parseFloat(item.total_price_per_units);
      actualCost += parseFloat(item.total_cost_per_units);
    });
    return {
      total: total.toFixed(2),
      actualCost: actualCost.toFixed(2),
      cash: ((receivedAmount * 1) - 0).toFixed(2),
      balance: (total - receivedAmount).toFixed(2)
    };
  };

  const confirmedOrder = (e) => {
    e.preventDefault();
    confirmAlert({
      title: "Confirm to place order",
      message: "Are you sure to do this.",
      buttons: [
        {
          label: "Yes",
          onClick: () => placeOrder(),
        },
        {
          label: "No",
          onClick: () => console.log("no"),
        },
      ],
    });
  };

  const placeOrder = async () => {
    setIsLoading(true);
    let obj = getTotalBill();
    try {
      let payload = {
        casier_id: user.id,
        shop_id: user.shop_id,
        total_selling_price: obj.total,
        total_actual_price: obj.actualCost,
        order_details: cartContext.cartItems,
      };

      let respond = await order_apis.make_order(payload);
      toast("Order placed successfully", {
        position: "top-right",
        autoClose: 5000,
        theme: "dark",
        type: "success",
      });
      handlePrint()
    } catch (err) {
      toast("There was an error. please try again later", {
        position: "top-right",
        autoClose: 5000,
        theme: "dark",
        type: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const printInvoice = () => {
    handlePrint();
  };

  const openModal = (e) => {
    e.preventDefault()
    setIsModalOpen(true);
  };

  const addAmount = (e) => {
    e.preventDefault()
    setIsModalOpen(false);
  }

  const closeModal = (e) => {
    e.preventDefault();
    setIsModalOpen(false);
    setRecievedAmount(0)
  };

  return (
    <div>
      <ToastContainer />
      <ScrollableFeed>
        <>
          {is_loading ? (
            <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-15 backdrop-blur z-50">
              <div role="status">
                <img src={loader} className="w-[200px] h-[200px]" />
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="flex flex-col justify-between text-white">
              <motion.div
                transition={{ duration: 0.5 }}
                exit={{ y: "50%", opacity: 0 }}
                className="flex flex-col px-4 py-4 space-y-1 h-[58vh] overflow-y-scroll scrollbar-hide"
              >
                <>
                  <div className="">
                    <ul role="list" className="divide-y divide-black">
                      <AnimatePresence>
                        <motion.li
                          initial={{ x: 100 }}
                          animate={{ x: 0 }}
                          transition={{ duration: 0.2 }}
                          exit={{ y: "50%", opacity: 0, scale: 0.5 }}
                        >
                          {cartContext.cartItems.length > 0 && (
                            <div className="px-4 py-2 space-y-5">
                              {cartContext.cartItems.map((element, index) => (
                                <div
                                  key={index}
                                  className="flex items-center justify-between"
                                >
                                  <p className="truncate text-xs font-medium text-white">
                                    {index + 1}. &nbsp;{element.name} &nbsp;
                                    <span
                                      style={{
                                        backgroundColor: "#0da538",
                                        padding: "2px 4px",
                                        borderRadius: "10px",
                                      }}
                                    >
                                      {element.neededAmount}
                                    </span>
                                  </p>
                                  <div className="ml-2 flex flex-shrink-0">
                                    <p className="inline-flex rounded-full px-2 text-xs font-semibold leading-5 text-white">
                                      LKR {element.total_price_per_units}
                                    </p>
                                    <p
                                      className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6"
                                      onClick={(e) => {
                                        cartContext.removeItem(element.id);
                                      }}
                                    >
                                      &nbsp;
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-x-circle"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                      </svg>
                                    </p>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </motion.li>
                      </AnimatePresence>
                    </ul>
                  </div>
                </>
                {cartContext.cartItems.length == 0 && (
                  <>
                    <div className="flex items-center justify-center h-full">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="w-8 h-8 text-[#474c54]"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
                        />
                      </svg>
                      <small className="text-[#474c54]">No items.</small>
                    </div>
                  </>
                )}
              </motion.div>
              <div className="flex flex-col w-full">
                <div>
                  <div className="grid grid">
                    <button disabled={cartContext.cartItems.length == 0} onClick={openModal} className="bg-[#151a34] text-center p-2 text-sm font-semibold hover:bg-[#1f2544] cursor-pointer border border-black">
                      <div disabled={cartContext.cartItems.length == 0} >Cash</div>
                    </button>
                  </div>
                  <div className="flex flex-col pl-8 pr-8 py-4 space-y-2">
                    <div className="flex flex-row items-center justify-between text font-bold ">
                      <p>Amount</p>
                      <p>LKR {getTotalBill().total}</p>
                    </div>
                    <div className="flex flex-row items-center justify-between text font-bold ">
                      <p>Cash</p>
                      <p>LKR {getTotalBill().cash}</p>
                    </div>
                    <div className="flex flex-row items-center justify-between text font-bold ">
                      <p>Balance</p>
                      <p>LKR {getTotalBill().cash == 0 ? '0.00' : (getTotalBill().cash - getTotalBill().total).toFixed(2)}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid grid gap-0 pt-2 text-center absolute bottom-0 w-full">
                {/* <div style={{ backgroundColor: "#3441d4" }}>
                  <button
                    disabled={cartContext.cartItems.length == 0}
                    onClick={printInvoice}
                    className="py-4 text-center pt-2"
                  >
                    Print Bill
                  </button>
                </div> */}
                <div
                  className={
                    cartContext.cartItems.length === 0 ||
                      receivedAmount === 0 ||
                      getTotalBill().cash*1 < getTotalBill().total*1
                      ? `bg-gray-500`
                      : `bg-[#5b45b0]`
                  }
                >
                  <button
                    style={{ fontWeight: "600" }}
                    disabled={
                      cartContext.cartItems.length === 0 ||
                      receivedAmount === 0 ||
                      getTotalBill().cash*1 < getTotalBill().total*1
                    }
                    onClick={confirmedOrder}
                    className={
                      cartContext.cartItems.length === 0 ||
                        receivedAmount === 0 ||
                        getTotalBill().cash*1 < getTotalBill().total*1
                        ? "py-4 text-center pt-2 cursor-not-allowed"
                        : "py-4 text-center pt-2"
                    }
                  >
                    Place Order
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      </ScrollableFeed>
      <div style={{ display: "none" }}>
        <Invoice
          ref={invoiceRef}
          user={user}
          cartItems={cartContext.cartItems}
          formattedDate={formattedDate}
          getBill={getTotalBill}
        />
      </div>

      <Model isOpen={isModalOpen} onClose={closeModal}>
        <div>
          <h2 className="text-xl font-bold mb-4" style={{ textAlign: 'center' }}>Cash</h2>
          <form className="p-4 md:p-5">
            <div className="grid gap-4 mb-4 grid-cols-1">
              <div className="col-span-2 sm:col-span-1">
                <label htmlFor="price" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Received Amount</label>
                <input disabled={getTotalBill().total == 0} onChange={(e) => { setRecievedAmount(e.target.value) }} type="number" name="price" id="price" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" />
              </div>
            </div>
            <div className="flex justify-end gap-4">
              <button onClick={closeModal} type="button" className="text-white inline-flex items-center bg-red-700 hover:bg-red-800 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-circle mr-2" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                </svg>
                Close
              </button>
              <button
                type="submit"
                onClick={addAmount}
                className="text-white inline-flex items-center bg-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-cart-plus mr-2"
                  viewBox="0 0 16 16"
                >
                  <path d="M9 5.5a.5.5 0 0 0-1 0V7H6.5a.5.5 0 0 0 0 1H8v1.5a.5.5 0 0 0 1 0V8h1.5a.5.5 0 0 0 0-1H9z" />
                  <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1zm3.915 10L3.102 4h10.796l-1.313 7zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0m7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                </svg>
                Recived
              </button>

            </div>
          </form>

        </div>
      </Model>
    </div>
  );
};

export default CartItems;
